import { Link } from "react-router-dom";
import { Button } from "../ui/Button";

export function Navbar() {
  return (
    <header className="border-b border-line bg-paper-raised/80 backdrop-blur">
      <div className="container-page flex h-16 items-center justify-between">
        <Link to="/" className="font-display text-lg text-ink">
          Callback
        </Link>
        <nav className="hidden items-center gap-8 text-sm text-ink-soft md:flex">
          <a href="#how-it-works" className="hover:text-ink">
            How it works
          </a>
          <a href="#features" className="hover:text-ink">
            Features
          </a>
          <a href="#pricing" className="hover:text-ink">
            Pricing
          </a>
          <a href="#faq" className="hover:text-ink">
            FAQ
          </a>
        </nav>
        <div className="flex items-center gap-3">
          <Link to="/login" className="text-sm font-medium text-ink-soft hover:text-ink">
            Log in
          </Link>
          <Link to="/signup">
            <Button className="px-4 py-2 text-sm">Get started</Button>
          </Link>
        </div>
      </div>
    </header>
  );
}
